import { render, staticRenderFns } from "./BankTransfer.vue?vue&type=template&id=3cff30a5&scoped=true&"
import script from "./BankTransfer.vue?vue&type=script&lang=js&"
export * from "./BankTransfer.vue?vue&type=script&lang=js&"
import style0 from "./BankTransfer.vue?vue&type=style&index=0&id=3cff30a5&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../Github/lmsv4_web_frontend_vue/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cff30a5",
  null
  
)

export default component.exports